
import { Vue, Component, Getter } from "nuxt-property-decorator"
import { GET_CREDIT_CODE_VALUE } from "~/store/credit-code/getters"

@Component
export default class CreditCode extends Vue {
  @Getter(GET_CREDIT_CODE_VALUE, { namespace: "credit-code" }) creditCodeValue: number | null
}
